import "./index.scss";
import {
  BaseCtaContentProps,
  CtaContentProps,
  LiveStyleCollection,
} from "./types";
import { Button } from "@wise-emotions/react-button";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import Chip from "components/Chip";
import React from "react";
import classNames from "classnames";
import parse from "html-react-parser";

const BaseCtaContent = ({
  classCustom = "",
  children,
}: BaseCtaContentProps) => {
  return <div className={classCustom}>{parse(children)}</div>;
};

const CtaContent = (props: CtaContentProps & LiveStyleCollection) => {
  const { label, customClass, ctaStyle, styleCollection } =
    useContentfulLiveUpdates({
      ...props,
      sys: {
        id: props.contentful_id || "",
      },
    });

  const classCtaContent = classNames("CtaContent__label", customClass);

  const liveCtaStyle = styleCollection ? styleCollection.items : ctaStyle;

  if (!liveCtaStyle?.length) {
    return (
      <BaseCtaContent classCustom={classCtaContent}>{label}</BaseCtaContent>
    );
  }

  return (
    <>
      {(() => {
        const { __typename: typename } = liveCtaStyle[0];

        switch (typename) {
          case "V2_ctaContentBtnStyle":
          case "ContentfulCtaContentBtnStyleV2":
            return (
              <div className={classCtaContent}>
                <Button
                  variant="default"
                  size={liveCtaStyle[0].size || "md"}
                  theme={liveCtaStyle[0].btnType}
                >
                  {label}
                </Button>
              </div>
            );

          case "V2_ctaContentChipStyle":
          case "ContentfulCtaContentChipStyleV2":
            return <Chip>{label}</Chip>;

          // NOTE: without style we have a normal label
          default:
            return (
              <BaseCtaContent classCustom={classCtaContent}>
                {label}
              </BaseCtaContent>
            );
        }
      })()}
    </>
  );
};

export default CtaContent;
